export { EditorClient as OutlookOnlineEditorClient } from '@editor/outlook-online';
export { DexLitePane } from '@editor/outlook-online';
